import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import axios from 'axios'
import {
    MINISHOP_INFO_REQUEST, MINISHOP_INFO_SUCCESS, MINISHOP_INFO_FAILURE,
    SEARCH_DATA_REQUEST, SEARCH_DATA_SUCCESS, SEARCH_DATA_FAILURE,
    SEARCH_PRICE_REQUEST, SEARCH_PRICE_SUCCESS, SEARCH_PRICE_FAILURE,
    ADV_LIST_REQUEST ,ADV_LIST_SUCCESS ,ADV_LIST_FAILURE,
    CURATION_REQUEST ,CURATION_SUCCESS ,CURATION_FAILURE,
    HOT_EVENT_REQUEST ,HOT_EVENT_SUCCESS ,HOT_EVENT_FAILURE,
    ITEM_LIST_REQUEST ,ITEM_LIST_SUCCESS ,ITEM_LIST_FAILURE,
} from '../reducers/initial'
import {ga4API2} from '../libs/googleTagmanager'

// minishopInfo
function minishopInfoAPI(data) {
    const url = `/front/v2/minishop/view/?mall_web_user=${data}`
    return axios.get(url)
}

function* minishopInfo(action) {
    try {
        const result = yield call(minishopInfoAPI, action.data)
        yield put({
            type: MINISHOP_INFO_SUCCESS,
            data: result.data.result,
        })
    } catch (e) {
        console.error(e)
        yield put({
            type: MINISHOP_INFO_FAILURE,
        })
    }
}

// searchData
function searchDataAPI(data) {
    const url = `/front/v1/item/spec/${data}`
    return axios.get(url)
}

function* searchData(action) {
    try {
        const result = yield call(searchDataAPI, action.data)
        yield put({
            type: SEARCH_DATA_SUCCESS,
            data: result.data.data,
        })
    } catch (e) {
        console.error(e)
        yield put({
            type: SEARCH_DATA_FAILURE,
        })
    }
}

// searchPrice
function searchPriceAPI(data) {
    const url = `/front/v1/item/getSchPrice/?cate_id=${data}`
    return axios.get(url)
}

function* searchPrice(action) {
    try {
        const result = yield call(searchPriceAPI, action.data)
        yield put({
            type: SEARCH_PRICE_SUCCESS,
            data: result.data.data,
        })
    } catch (e) {
        console.error(e)
        yield put({
            type: SEARCH_PRICE_FAILURE,
        })
    }
}

// advList
function advListAPI({cate, idx_b_manager, domain}) {
    let adv = ''
    if (domain === 'shopping') adv = 'sap006'
    else adv = 'sap001'
    const url = `/front/v3/items?cate_id=${cate}&idx_b_manager=${idx_b_manager}&ad=${adv}&fields=stdpc,maker,hotdeal,event`
    const config = {
        withCredentials: true,
        xsrfHeaderName: 'Authorization',
    }
    return axios.get(url, config)
}

function* advList(action) {
    try {
        const result = yield call(advListAPI, action.data)
        yield put({
            type: ADV_LIST_SUCCESS,
            data: result.data.result,
        })
    } catch (e) {
        console.error(e)
        yield put({
            type: ADV_LIST_FAILURE,
        })
    }
}

// curation
function curationAPI({cate, idx_b_manager, domain, search}) {
    let adv = ''
    if (domain === 'shopping') adv = 'svp003'
    else adv = 'svp004'

    let url = `/front/v3/curation/${cate}/${idx_b_manager}?ad=${adv}`
    const searchQueryStringAdCode = new URLSearchParams(search).get('ad_code')

    if (searchQueryStringAdCode === adv) {
        url = `/front/v3/curation/${cate}/${idx_b_manager}?ad=${adv}&${search.slice(1)}`
    }
    const config = {
        withCredentials: true,
        xsrfHeaderName: 'Authorization',
    }
    return axios.get(url, config)
}

function* curation(action) {
    try {
        /**
         * GA4 태그 API2 구글태그매니저
         * */
        const {domain,cate}=action.data
        if (domain === 'shopping' || domain === 'pc') {
            let adv = ''
            if (domain === 'shopping') adv = 'sap006'
            else adv = 'sap001'
            ga4API2(adv,cate)
        }

        const result = yield call(curationAPI, action.data)
        yield put({
            type: CURATION_SUCCESS,
            data: result.data.result,
        })
    } catch (e) {
        console.error(e)
        yield put({
            type: CURATION_FAILURE,
        })
    }
}

// hotEvent
function hotEventAPI(cate) {
    const url = `/front/v1/event/category/${cate}`
    const config = {
        withCredentials: true,
        xsrfHeaderName: 'Authorization',
    }
    return axios.get(url, config)
}

function* hotEvent(action) {
    try {
        const result = yield call(hotEventAPI, action.data)
        yield put({
            type: HOT_EVENT_SUCCESS,
            data: result.data.result.totalcount === 0 ? [] : result.data.result.list,
        })
    } catch (e) {
        console.error(e)
        yield put({
            type: HOT_EVENT_FAILURE,
        })
    }
}

// itemList
function itemListAPI(data) {
    const url = `/front/v3/items`
    const params = data
    const config = {
        params,
        withCredentials: true,
        xsrfHeaderName: 'Authorization',
    }
    return axios.get(url, config)
}

function* itemList(action) {
    try {
        const result = yield call(itemListAPI, action.data)
        yield put({
            type: ITEM_LIST_SUCCESS,
            data: result.data.result,
        })
    } catch (e) {
        console.error(e)
        yield put({
            type: ITEM_LIST_FAILURE,
        })
    }
}

// watch
function* watchMinishopInfo() {
    yield takeLatest(MINISHOP_INFO_REQUEST, minishopInfo)
}

function* watchSearchData() {
    yield takeLatest(SEARCH_DATA_REQUEST, searchData)
}

function* watchSearchPrice() {
    yield takeLatest(SEARCH_PRICE_REQUEST, searchPrice)
}

function* watchAdvList() {
    yield takeLatest(ADV_LIST_REQUEST, advList)
}

function* watchCurationList() {
    yield takeLatest(CURATION_REQUEST, curation)
}

function* watchHotEventList() {
    yield takeLatest(HOT_EVENT_REQUEST, hotEvent)
}

function* watchItemListList() {
    yield takeLatest(ITEM_LIST_REQUEST, itemList)
}

export default function* initialSaga() {
    yield all([fork(watchMinishopInfo)])
    yield all([fork(watchSearchData)])
    yield all([fork(watchSearchPrice)])
    yield all([fork(watchAdvList)])
    yield all([fork(watchCurationList)])
    yield all([fork(watchHotEventList)])
    yield all([fork(watchItemListList)])
}



// WEBPACK FOOTER //
// ./src/estimate_list/sagas/initial.js